var map = {
	"./cast.svg": 1406,
	"./cc-off.svg": 888,
	"./cc-on.svg": 539,
	"./close.svg": 1407,
	"./embed.svg": 1408,
	"./facebook.svg": 893,
	"./fullscreen-off.svg": 890,
	"./fullscreen-on.svg": 889,
	"./fw-15.svg": 883,
	"./left.svg": 1409,
	"./link.svg": 895,
	"./live.svg": 879,
	"./pause-big.svg": 898,
	"./pause.svg": 882,
	"./play-big.svg": 897,
	"./play-resume.svg": 540,
	"./play-round.svg": 900,
	"./play-small.svg": 1410,
	"./play.svg": 881,
	"./quality-100.svg": 901,
	"./replay.svg": 899,
	"./right.svg": 1411,
	"./rw-15.svg": 884,
	"./settings.svg": 891,
	"./sharing.svg": 892,
	"./speed.svg": 896,
	"./toggle-pause.svg": 1412,
	"./toggle-play.svg": 1413,
	"./twitter.svg": 894,
	"./volume-0.svg": 885,
	"./volume-100.svg": 887,
	"./volume-50.svg": 886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1405;